import { render } from "./DoctorSurveyResult.vue?vue&type=template&id=5ef38680"
import script from "./DoctorSurveyResult.vue?vue&type=script&lang=js"
export * from "./DoctorSurveyResult.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__